import { motion } from "framer-motion";
import { 
  GiHoneypot, GiStrawberry, GiPeach, GiOrange, GiGrapes, GiRaspberry, 
  GiFlowerEmblem, GiWrappedSweet, GiButter, GiFruitTree, GiCutLemon 
} from "react-icons/gi";
import { DiRasberryPi } from "react-icons/di";
import { LuCitrus } from "react-icons/lu";
import { FaAppleAlt, FaSun } from "react-icons/fa";
import { PiCheese } from "react-icons/pi";

const iconMap = {
  honey: GiHoneypot,
  strawberry: GiStrawberry,
  apricot: GiPeach,
  berry: DiRasberryPi,
  citrus: LuCitrus,
  apple: FaAppleAlt,
  grapefruit: GiOrange,
  grape: GiGrapes,
  blueberry: GiRaspberry,
  flowery: GiFlowerEmblem,
  sweet: GiWrappedSweet,
  cheese: PiCheese,
  butter: GiButter,
  tropical: FaSun,
  treefruit: GiFruitTree,
  lemon: GiCutLemon,
};

export default function Ingredients({ ingredients, strainInfo }) {
  return (
    <div className="ingredients-container">
      {strainInfo && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="strain-info"
        >
          {strainInfo}
        </motion.div>
      )}

      <div className="ingredients-row">
        {ingredients.map((item, index) => {
          const key = item.toLowerCase();
          const Icon = iconMap[key];
          return (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="ingredient-item"
            >
              {Icon && <Icon className="ingredient-icon" />}
              <span>{item}</span>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
